import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${colors.secondary95};
  padding: 3px 8px;
  border-radius: 12px;
`

const StyledItem = styled.div`
  font-size: 10px;
  display: flex;
  align-items: center;
  margin-right: 15px;

  &:last-child {
    margin-right: 0;
  }
`

const ColorCircle = styled.div`
  background: ${props => props.color};
  border-radius: 5px;
  width: 8px;
  height: 8px;
  margin-right: 3px;
`

const StyledLabel = styled.div`
  margin-bottom: 1px;
  color: #000;
`

const LegendItem = ({ color, label }) => {
  return (
    <StyledItem>
      <ColorCircle color={color} />
      <StyledLabel>{label}</StyledLabel>
    </StyledItem>
  )
}

LegendItem.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
}

const LegendBar = ({ items, className }) => {
  return (
    <StyledWrapper className={className}>
      {items.map(item => (
        <LegendItem
          key={`${item.color}_${item.label}`}
          color={item.color}
          label={item.label}
        />
      ))}
    </StyledWrapper>
  )
}

LegendBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
    })
  ),
}

export default LegendBar
